import React from "react";
import { MessageDiv } from "pages/CareDashboard/CareDashboardList";
import Lottie from "react-lottie";
import { FlexColumn } from "components/core/Cards/styles";
import emptyFile from "assets/lottie/empty_file.json";
import { Ptag } from "components/core/fonts";

function EmptyDataLottie({ text }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: emptyFile,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <MessageDiv>
      <FlexColumn>
        <Lottie
          options={defaultOptions}
          height={120}
          width={120}
          style={{ opacity: "1" }}
          isClickToPauseDisabled
        />
        <Ptag fontSize="18px" fontWeight="600" lineHeight="20" fontFamily="Montserrat">
          {text}
        </Ptag>
      </FlexColumn>
    </MessageDiv>
  );
}

export default EmptyDataLottie;
